import { generateFormItemName } from ".";
import type { ButtonType, ButtonVariant } from ".";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-shared/uikit/Form";
import { Accordion } from "@circle-react-uikit/Accordion";
import type { FlattenedCssVariables } from "../index";

interface BackgroundProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
  customColors: Record<string, string>;
  flattenedCssVariables: FlattenedCssVariables;
  onAddCustomColor: (color: string) => void;
  themeColors: FlattenedCssVariables;
}

export const Background = ({
  buttonType,
  buttonVariant,
  flattenedCssVariables,
  themeColors,
  customColors,
  onAddCustomColor,
}: BackgroundProps) => (
  <div className="px-6 pt-5">
    <Accordion defaultOpen>
      <Accordion.Item
        title={t(
          "builder_ui.theme_configuration.site_styles.button_styles.background",
        )}
      >
        <Form.Item
          hideBorder
          isFirstChild
          hideDescription
          name={generateFormItemName(
            buttonType,
            buttonVariant,
            "background-color",
          )}
          label={t(
            "builder_ui.theme_configuration.site_styles.button_styles.fill_opacity_and_color",
          )}
          className="!flex !w-full !items-center !justify-between"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(
              buttonType,
              buttonVariant,
              "background-color",
            )}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
            shouldRenderThemeColors
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={onAddCustomColor}
          />
        </Form.Item>
      </Accordion.Item>
    </Accordion>
  </div>
);
